import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IDataEntryForm } from "./../models/data-entry.model";

@Injectable({
  providedIn: "root",
})
export class FormTemplateDataEntryService {
  constructor(private http: HttpClient) {}

  async getFormTemplateAsync(formTemplateName: string) {
    const basePath = "assets/formtemplates/";
    const template = await this.http
      .get<IDataEntryForm>(basePath + formTemplateName + ".json")
      .toPromise();
    // console.log("url", template);
    return template;
  }

  async getFormTemplateAsyncForNFZ(formTemplateName: string, refCode?: string) {
    const nfzBasePath = "assets/nfz-formtemplates/";
    let url: string;
  
    url = nfzBasePath + formTemplateName + "-isNFZ.json";
  
    // Append the query parameter
    url += "?d=nfzRedirection";
  
    // console.log("url", url);
    const template = await this.http.get<IDataEntryForm>(url).toPromise();
    return template;
  }
  

  getFormTemplate(formTemplateName) {
    var template = this.http.get<IDataEntryForm>(
      "assets/formtemplates/" + formTemplateName + ".json"
    );
    return template;
  }
}
